import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6" }
const _hoisted_2 = { class: "2xl:container 2xl:mx-auto md:py-12 lg:px-20 md:px-6 py-9 px-4" }
const _hoisted_3 = { class: "w-full flex flex-col justify-content-center items-center" }
const _hoisted_4 = { class: "font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-curaduria" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "lg:text-lg text-lg text-justify lg:leading-9 md:leading-7 leading-9 text-black mt-2 font-normal" }, " La licencia urbanística es el acto administrativo de carácter particular y concreto, expedido por el curador urbano o la autoridad municipal o distrital competente, por medio del cual se autoriza específicamente a adelantar obras de urbanización y parcelación de predios, de construcción, ampliación, modificación, adecuación, reforzamiento estructural, restauración, reconstrucción, cerramiento y demolición de edificaciones, de intervención y ocupación del espacio público, y realizar el loteo o subdivisión de predios. El otorgamiento de la licencia urbanística implica la adquisición de derechos de desarrollo y construcción en los términos y condiciones contenidos en el acto administrativo respectivo, así como la certificación del cumplimiento de las normas urbanísticas y sismo resistentes y demás reglamentaciones en que se fundamenta, y conlleva la autorización específica sobre uso y aprovechamiento del suelo en tanto esté vigente o cuando se haya ejecutado la obra siempre y cuando se hayan cumplido con todas las obligaciones establecidas en la misma. (Decreto Nacional 1077 de 2015, artículo 2.2.6.1.1.1., modificado por el art. 2, Decreto Nacional 1203 de 2017). ", -1)

import Footer from "../Reusables/Footer.vue";
import Header from "../Reusables/Header.vue";
import LicenceConstruction from "./LicenceConstruction.vue";
import LicenceParcel from "./LicenceParcel.vue";
import LicenceSubdiv from "./LicenceSubdiv.vue";
import LicenceUrb from "./LicenceUrb.vue";
import OtherActions from "./OtherActions.vue";
import ReconExistEdif from "./ReconExistEdif.vue";
import ReqOtherActions from "./ReqOtherActions.vue";
import LicenceProrroga from "./LicenceProrroga.vue";
import LicenceModification from "./LicenceModification.vue";
import LicenceRevalidation from "./LicenceRevalidation.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("licences.title")), 1),
          _hoisted_5
        ]),
        _createVNode(LicenceUrb),
        _createVNode(LicenceParcel),
        _createVNode(LicenceSubdiv),
        _createVNode(LicenceConstruction),
        _createVNode(LicenceModification),
        _createVNode(LicenceProrroga),
        _createVNode(LicenceRevalidation),
        _createVNode(OtherActions),
        _createVNode(ReqOtherActions),
        _createVNode(ReconExistEdif)
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})